import { render } from "./MovieShow.vue?vue&type=template&id=6f2de052&scoped=true"
import script from "./MovieShow.vue?vue&type=script&lang=js"
export * from "./MovieShow.vue?vue&type=script&lang=js"

import "./MovieShow.vue?vue&type=style&index=0&id=6f2de052&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2de052"]])

export default __exports__